'use client';

import { ReactElement } from 'react';

import { FontSizes, FontWeights, Text } from '@calm-web/design-system';

import { useScreenDidMount } from '../../hooks';
import { useSisu } from '../../Provider';
import { isFormattedMessage, type MessageNode } from '../../utils';
import { Copy, ErrorPageWrap, Wrapper } from './styles';

export type ErrorScreenProps = {
	/**
	 * @defaultValue
	 * ```tsx
	 * "sisu-error"
	 * ```
	 */
	'data-testid'?: string;

	header?: ReactElement;
	onScreenDidMount?: () => void;
	title?: MessageNode;
	subtitle?: MessageNode;
};

export default function ErrorScreen({
	'data-testid': testId = 'sisu-error',
	header,
	onScreenDidMount,
	title,
	subtitle,
}: ErrorScreenProps) {
	const { activeScreen, backgroundColor } = useSisu();

	useScreenDidMount('error', () => {
		onScreenDidMount?.();
	});

	if (activeScreen !== 'error') {
		return null;
	}

	return (
		<>
			{header}
			<ErrorPageWrap backgroundColor={backgroundColor} data-testid={testId}>
				<Wrapper>
					<Copy>
						{title && isFormattedMessage(title) ? (
							<Text el="h1" noMargin size={FontSizes['2xl']} weight={FontWeights.Demi}>
								{title}
							</Text>
						) : (
							title
						)}
						{subtitle && isFormattedMessage(subtitle) ? (
							<Text el="h2" noMargin size={FontSizes.base} weight={FontWeights.Regular}>
								{subtitle}
							</Text>
						) : (
							subtitle
						)}
					</Copy>
				</Wrapper>
			</ErrorPageWrap>
		</>
	);
}
